export const IShowPopUpUseCaseType = Symbol('IShowErrorUseCase');
